import {observer} from 'mobx-react-lite';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import CustomerQuoteFormStore from '../FormStore';
import QuoteCarrierField from './QuoteCarrierField';

const QuoteBestValueFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getQuoteErrors();
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Permanent Coverage"
                    defaultValue={state.quote.get('user_selected_perm_coverage')}
                    error={!!errors.user_selected_perm_coverage}
                    helperText={errors?.user_selected_perm_coverage}
                    onChange={(e) => {
                        state.setQuote(
                            'user_selected_perm_coverage',
                            e.target.value ? parseInt(e.target.value, 10) : undefined,
                        );
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Term Coverage"
                    defaultValue={state.quote.get('user_selected_term_coverage')}
                    error={!!errors.user_selected_term_coverage}
                    helperText={errors?.user_selected_term_coverage}
                    onChange={(e) => {
                        state.setQuote(
                            'user_selected_term_coverage',
                            e.target.value ? parseInt(e.target.value, 10) : undefined,
                        );
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Cash Value Amount"
                    defaultValue={state.quote.get('user_selected_cv_amt')}
                    error={!!errors.user_selected_cv_amt}
                    helperText={errors?.user_selected_cv_amt}
                    onChange={(e) => {
                        state.setQuote(
                            'user_selected_cv_amt',
                            e.target.value ? parseInt(e.target.value, 10) : undefined,
                        );
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Cash Value Age"
                    defaultValue={state.quote.get('cash_value_age')}
                    error={!!errors.cash_value_age}
                    helperText={errors?.cash_value_age}
                    onChange={(e) => {
                        state.setQuote('cash_value_age', e.target.value ? parseInt(e.target.value, 10) : undefined);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Permanent Premium"
                    defaultValue={state.quote.get('user_selected_perm_premium')}
                    error={!!errors.user_selected_perm_premium}
                    helperText={errors?.user_selected_perm_premium}
                    onChange={(e) => {
                        state.setQuote(
                            'user_selected_perm_premium',
                            e.target.value ? parseInt(e.target.value, 10) : undefined,
                        );
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    type="number"
                    margin="normal"
                    label="Term Premium"
                    defaultValue={state.quote.get('user_selected_term_premium')}
                    error={!!errors.user_selected_term_premium}
                    helperText={errors?.user_selected_term_premium}
                    onChange={(e) => {
                        state.setQuote(
                            'user_selected_term_premium',
                            e.target.value ? parseInt(e.target.value, 10) : undefined,
                        );
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <QuoteCarrierField state={state} />
            </Grid>
        </Grid>
    );
});

export default QuoteBestValueFields;
